import React from 'react';

const AWS_Connectivity = () => {
  return (
    <div>
      <h1>AWS_Connectivity</h1>
      <p>This is the AWS_Connectivity component.</p>
    </div>
  );
};

export default AWS_Connectivity;
